// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_9g-3";
export var contentContainer = "_9g-0";
export var editorContainer = "_9g-1";
export var quillInputForm = "_9g-2";
export var zoneDivider = "_9g-4";